import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { PaginationResponse } from "@/core/services/api/interfaces/PaginationResponse";
import ApiService from "@/core/services/ApiService";
import { WalletUnit } from "@/core/services/api/interfaces/manager/Crypto";

@Module
export default class WalletsModule extends VuexModule {
  pagination = new PaginationResponse<WalletUnit>();
  loading = false;

  get wallets(): WalletUnit[] {
    return this.pagination.data;
  }

  get walletsByNetwork() {
    return (network): WalletUnit[] => {
      if (!network) {
        return [];
      }

      return this.pagination.data.filter((value: WalletUnit) => {
        return value.network.value === network;
      });
    };
  }

  get walletsLoading(): boolean {
    return this.loading;
  }

  get walletsPagination(): PaginationResponse<WalletUnit> {
    return this.pagination;
  }

  get walletsTotal(): number {
    return this.pagination.total;
  }

  get walletsRequired(): boolean {
    return !this.pagination.total && !this.loading;
  }

  get walletsCurrentPage(): number {
    return this.pagination.current_page;
  }

  get walletsPerPage(): number {
    return this.pagination.per_page;
  }

  @Action({ rawError: true })
  [Actions.MANAGER_COMPANY_WALLETS_LOAD](params) {
    this.context.commit(Mutations.MANAGER_COMPANY_WALLETS_SET_LOADING, true);

    return ApiService.manager.crypto.wallets
      .list({
        params: params,
      })
      .then(ApiService.unwrapPaginationResponse)
      .then((response) => {
        this.context.commit(Mutations.MANAGER_COMPANY_WALLETS_SET, response);
      })
      .catch(console.error)
      .finally(() => {
        this.context.commit(
          Mutations.MANAGER_COMPANY_WALLETS_SET_LOADING,
          false
        );

        this.context.commit(
          Mutations.COMMON_REQUEST_DONE,
          Actions.MANAGER_COMPANY_WALLETS_LOAD
        );
      });
  }

  @Action({ rawError: true })
  [Actions.MANAGER_COMPANY_WALLETS_CREATE](params) {
    this.context.commit(Mutations.MANAGER_COMPANY_WALLETS_SET_LOADING, true);

    return ApiService.manager.crypto.wallets
      .create(params)
      .then(ApiService.unwrapItemResponse);
  }

  @Action({ rawError: true })
  async [Actions.MANAGER_COMPANY_WALLETS_DELETE](id) {
    this.context.commit(Mutations.MANAGER_COMPANY_WALLETS_SET_LOADING, true);

    return ApiService.manager.crypto.wallets
      .delete(id)
      .then(ApiService.unwrapPaginationResponse)
      .then((response) => {
        this.context.commit(Mutations.MANAGER_COMPANY_WALLETS_SET, response);
        this.context.commit(
          Mutations.MANAGER_COMPANY_WALLETS_SET_LOADING,
          false
        );

        this.context.commit(
          Mutations.COMMON_REQUEST_DONE,
          Actions.MANAGER_COMPANY_WALLETS_LOAD
        );
      });
  }

  @Mutation
  [Mutations.MANAGER_COMPANY_WALLETS_SET](
    pagination: PaginationResponse<WalletUnit>
  ) {
    this.pagination = pagination;
  }

  @Mutation
  [Mutations.MANAGER_COMPANY_WALLETS_RESET]() {
    this.pagination = new PaginationResponse<WalletUnit>();
  }

  @Mutation
  [Mutations.MANAGER_COMPANY_WALLETS_SET_LOADING](loading: boolean) {
    this.loading = loading;
  }
}
